// #147: detecção de live encerrada. /me/streams (Twitch) refetcha a cada 30s; uma
// live que some da resposta encerrou. Em vez de manter viewerCount/title congelados
// pra sempre (UX confuso: "12.400 viewers" numa live que acabou), contamos ciclos
// consecutivos ausente e marcamos como stale após o threshold.

/** Ciclos consecutivos ausente antes de marcar a live como encerrada. */
export const STALE_THRESHOLD = 2;

/**
 * Atualiza o contador de "misses" (ciclos ausente) por liveChatId.
 *
 * - Presente na resposta → zera (live ativa).
 * - Ausente → incrementa.
 * - liveChatIds fora do painel são descartados (não acumulam lixo).
 *
 * Função pura: recebe o estado anterior e devolve o próximo, sem mutar.
 */
export function updateMissCounts(
  prev: Record<string, number>,
  trackedLiveChatIds: readonly string[],
  presentLiveChatIds: ReadonlySet<string>,
): Record<string, number> {
  const next: Record<string, number> = {};
  for (const id of trackedLiveChatIds) {
    next[id] = presentLiveChatIds.has(id) ? 0 : (prev[id] ?? 0) + 1;
  }
  return next;
}

export function isStale(missCount: number | undefined): boolean {
  return (missCount ?? 0) >= STALE_THRESHOLD;
}
